export const PDFViewerStyles = {
    'container': 'w-full max-h-screen relative'
};